import FoundationFieldContainer from './foundation_field_container';

const FoundationField = FoundationFieldContainer;

export default FoundationField;
